module.exports = __webpack_public_path__ + "img/Weapon_50.74b2d51f.png";